import { Card, Space, Tag, Typography } from 'antd';
import { IActionLog } from 'interfaces/action_log';
import { PageHeader } from 'components/professor_area/PageHeader';
import { SettingOutlined } from '@ant-design/icons';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const ActionLogShow = () => {
  const { queryResult } = useShow<IActionLog>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader
        title="Visualizar log de ações"
        icon={SettingOutlined}
        meta={
          <Space>
            <Tag>{record?.resource_kind}</Tag>
          </Space>
        }
      />
      <Card>
        <Title level={5}>ID</Title>
        <Text>{record?.id}</Text>
        <Title level={5}>Id do recurso</Title>
        <Text>{record?.resource_id}</Text>
        <Title level={5}>Tipo do recurso</Title>
        <Text>{record?.resource_kind}</Text>
        <Title level={5}>Informações do recurso</Title>
        <Text>
          <pre>{record?.resource_info.toString()}</pre>
        </Text>
      </Card>
    </ShowLayout>
  );
};
